import React, { useState, useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

export const HelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  useEffect(() => {
    return actions.recv("open-help", function () {
      setOpen(true);
    });
  }, []);

  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }
  return (
    <Modal
      title="Cluster Dashboard"
      onClose={doClose}
      content={() => (
        <>
          <p>
            <strong> BQNs </strong>
          </p>
          <p>
            Click on each BQN to access specific Dashboard
          </p>
        </>
      )}
    />
  );
};
